import { employeeHiringLink } from './employeeHiringLink';

export const esCr = {
  ...employeeHiringLink,
};
